
import { Helmet } from 'react-helmet-async';

interface PageHeadProps {
  title: string;
  description?: string;
}

const PageHead = ({ title, description }: PageHeadProps) => {
  return (
    <Helmet>
      <title>Visanow - {title}</title>
      {description && <meta name="description" content={description} />}
      {/* Google AdSense Script */}
      <script 
        async 
        src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-0483659727992282"
        crossOrigin="anonymous"
      />
    </Helmet>
  );
};

export default PageHead;
